import { Badge } from "../components/UI/Badge";

export const STATUS_BADGES = {
  Pending: Badge.blue,
  InventoryReserved: Badge.main,
  AwaitingPayment: Badge.main,
  AwaitingConfirmation: Badge.main,
  Paid: Badge.green,
  Processing: Badge.main,
  Shipped: Badge.blue,
  Delivered: Badge.green,
  Cancelled: Badge.red,
  PaymentFailed: Badge.red,

  PendingReview: Badge.blue,
  Approved: Badge.green,
  Substituted: Badge.main,
  Unavailable: Badge.red,
};

export const statusBadge = (status) => {
  const badge = STATUS_BADGES[status] || Badge.blue;
  return badge(status);
};
